"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Quote = void 0;
/**
 * Class to describe a quote object
 */
class Quote {
    constructor(elem, position, distance, message, color, rotate = false, ignoreLeft = false, ignoreRight = false, extendDirection = "") {
        this.quotesPart = [];
        this.elem = elem;
        this.position = position;
        this.distance = distance;
        this.color = color;
        this.message = message;
        this.rotate = rotate;
        this.ignoreLeft = ignoreLeft;
        this.ignoreRight = ignoreRight;
        this.extendDirection = extendDirection;
    }
}
exports.Quote = Quote;
